<template>
  <div class="core-metrics" :class="{ 'core-metrics--direct': theme === 'direct' }">
    <div class="core-target-row">
      <span class="core-target-num">{{ fmtValue(goal.target, goal.unit) }}</span>
      <span class="field-unit core-target-unit">{{ goal.unit }}</span>
    </div>
    <div class="core-stat-row">
      <div class="core-stat">
        <span class="field-label">已完成</span>
        <span class="field-value core-stat-value">
          {{ fmtValue(goal.completed, goal.unit) }}
          <span class="field-unit">{{ goal.unit }}</span>
        </span>
      </div>
      <div class="core-stat">
        <span class="field-label">达成率</span>
        <span class="field-value core-stat-value">{{ Number(goal.rate || 0).toFixed(2) }}%</span>
      </div>
    </div>
    <div class="core-progress-track">
      <div
        class="core-progress-fill"
        :class="{ 'core-progress-fill--direct': theme === 'direct' }"
        :style="{ width: Math.min(100, Number(goal.rate || 0)) + '%' }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreGoalMetrics',
  props: {
    goal: { type: Object, required: true },
    fmtValue: { type: Function, required: true },
    theme: { type: String, default: 'dealer' },
  },
}
</script>

<style scoped>
.field-label {
  color: #8c8c8c;
  font-size: 14px;
  font-weight: 400;
}

.field-value {
  color: #262626;
  font-size: 15px;
  font-weight: 600;
}

.field-unit {
  color: #262626;
  font-size: 15px;
  font-weight: 400;
}

.core-target-row {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 12px;
}

.core-target-num {
  font-size: clamp(23px, 2.5vw, 29px);
  font-weight: 600;
  color: #262626;
  line-height: 1.1;
}

.core-target-unit {
  color: #8c8c8c;
  padding-bottom: 2px;
}

.core-stat-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.core-stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.core-stat-value {
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
  flex-wrap: wrap;
}

.core-progress-track {
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
}

.core-progress-fill {
  height: 100%;
  border-radius: 3px;
  background: linear-gradient(90deg, #69b1ff, #1890ff);
  transition: width 0.3s ease;
}

.core-progress-fill--direct {
  background: linear-gradient(90deg, #91d5ff, #40a9ff);
}

.core-metrics--direct .core-target-num {
  color: #1890ff;
}
</style>
